import { useDarkMode, useOrganizations } from '@blend-ed/blendx-platform/hooks';
import { Image, useToast } from "@blend-ed/blendx-ui";
import { getConfig } from "@edx/frontend-platform";
import { FormattedMessage, injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import Cookies from 'js-cookie';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import messages from './messages';
import { refreshUserToken } from '@blend-ed/blendx-platform/utils';

const Organizations = ({ intl }) => {
  const navigate = useNavigate();
  const showToast = useToast();
  const next = new URLSearchParams(window.location.search).get('next');

  const { data: orgList, loading } = useOrganizations();
  const { MINIO_BASE_URL, LMS_BASE_URL } = getConfig()
  const orgName = Cookies.get('orgName');

  const handleOrganizationClick = async (org) => {
    try {
      await refreshUserToken();
      const domain = `.${LMS_BASE_URL.split('://')[1].split(':')[0]}`;
      Cookies.set('orgName', org.name, { path: '/', domain });

      if (next) {
      window.location.href = next;
      } else {
        navigate('/', { replace: true });
      }
    } catch (error) {
      console.error('Failed to refresh token:', error);
      showToast('close', 'error', 
        <div>
          Please <a href={`${LMS_BASE_URL}/logout`} style={{ color: 'var(--white)', textDecoration: 'underline', fontWeight: 500 }}>login again</a> to access this organization
        </div>
      );
    }
  };

  const { isDarkMode } = useDarkMode()

  useEffect(() => {
    if (orgName && next) {
      window.location.href = next;
    }
  }, []);

  if (orgList?.length === 1) {
    handleOrganizationClick(orgList[0]);
    return null;
  }

  if (loading) {
    return null;
  }

  return (
    <main className="organizations-container">
      <div className="organizations-header">
        <h4>
          <FormattedMessage {...messages.selectOrganization} />
        </h4>
      </div>
      <div className="organizations">
        {loading ? <div>Loading...</div> : orgList?.map((org) => (
          <div key={org.id} className="organization-col" onClick={() => handleOrganizationClick(org)}>
            <div className="organization-item">
              <Image
                src={MINIO_BASE_URL ? MINIO_BASE_URL + `/openedx/openedx/media/organisation-logos/${org.name}/${isDarkMode ? 'dark-' : ''}logo.png` : LMS_BASE_URL + `/media/organisation-logos/${org.name}/${isDarkMode ? 'dark-' : ''}logo.png`}
                alt={intl.formatMessage(
                  {
                    id: `organizations.${org.name}.logo.alt`,
                    defaultMessage: org.name
                  }
                )}
                fluid
                className="organization-logo"
              />
              <div className="organization-name">{org._Organisations.name}</div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
};

Organizations.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Organizations);
